import { selector } from 'recoil';

import memberInfoAtom from '~/recoil/atom/memberInfo';
import uidAtom from '~/recoil/atom/uid';

import * as fp from 'lodash/fp';

const isHost = selector<boolean>({
  key: 'isHost',
  get: ({ get }) => {
    const memberInfo = get(memberInfoAtom);
    const uid = get(uidAtom);

    return fp.eq(memberInfo.id, uid);
  },
});

export default isHost;
